export const dynamicColumnWidth = 100;
export const maxDynamicColumns = 20; // TODO Config
